// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2Rh_f","alertButton":"App_alertButton__HAFPY","buttonRow":"App_buttonRow__3txFJ","buttonRowText":"App_buttonRowText__14vDu"};